export default __webpack_public_path__ + "static/11-b98cbb81841225a36883d88120269152.jpg";